import TotalDeductionTable from './Table';
import styles from './index.module.scss';

type totalDeductionProps = {
	selectedPayrollId: string;
	onlyView: boolean;
	headerData: any;
	setIsUniversalLoading: any;
	payPeriodId: any;
	year: number;
	showSteps: boolean;
};
const TotalDeductionComponent = (props: totalDeductionProps) => {
	const {
		selectedPayrollId,
		onlyView,
		headerData,
		setIsUniversalLoading,
		payPeriodId,
		year,
		showSteps,
	} = props;

	return (
		<div className={styles['total-deduction__table']}>
			<TotalDeductionTable
				selectedPayrollId={selectedPayrollId}
				onlyView={onlyView}
				setIsUniversalLoading={setIsUniversalLoading}
				headerData={headerData}
				payPeriodId={payPeriodId}
				year={year}
				showSteps={showSteps}
			/>
		</div>
	);
};

export default TotalDeductionComponent;
